
import React from 'react';
import { connect } from 'react-redux';
import { Col, Row, Nav, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { IoIosChatboxes, IoIosWarning } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import { Icon } from '@blueprintjs/core';

import withNavigationDeviceProps from './withNavigationDeviceProps';

// Other
import DeviceContextMenu from './DeviceContextMenu';
import { getDevices, getDevice } from '../selectors';
import { getCurrentOrganisationHasProductCode } from '../../organisation/selectors';
import { isAdmin as getIsAdmin, isSuperAdmin as getIsSuperAdmin } from '../../user/selectors';

function EquipmentNav({ device={}, hasNetworkFeature, hasFmlog, isAdmin, isSuperAdmin }) {
  const { t } = useTranslation();
  return (
    <Nav as="ul" className="flex-grow-1">
      <Row className="small-gutters flex-grow-1">
        <Col xs="auto">
          {device.serial && !device.archived && (
            <Row className="small-gutters">
              <Col xs="auto" className="mb-1">
                <LinkContainer to={`/devices/${device.id}`} exact>
                  <Button size="md" variant="outline-secondary">
                    <IoIosChatboxes size="1.2em"
                    /> <span>{t('components.equipment.device-nav.activity')}</span>
                  </Button>
                </LinkContainer>
              </Col>
              {hasNetworkFeature && (
                <Col xs="auto" className="mb-1">
                  <LinkContainer to={`/devices/${device.id}/network`} exact>
                    <Button size="md" variant="outline-secondary">
                      <Icon
                        iconSize="1.1em"
                        icon="graph"
                        title="Network"
                        style={{ width: '1.1em', verticalAlign: '-12%' }}
                      /> <span>{t('components.equipment.device-nav.network')}</span>
                    </Button>
                  </LinkContainer>
                </Col>
              )}
              {((hasFmlog && isAdmin) || isSuperAdmin) && (
                <Col xs="auto" className="mb-1">
                  <LinkContainer to={`/devices/${device.id}/errors`} exact>
                    <Button size="md" variant="outline-secondary">
                      <IoIosWarning size="1.2em" /> {t('components.equipment.device-nav.error-log')}
                    </Button>
                  </LinkContainer>
                </Col>
              )}
            </Row>
          )}
        </Col>
        {/*  when this column overflows, ensure is is right-aligned using ml-auto */}
        <Col xs="auto" className="ml-auto">
          <Row className="small-gutters">
            {!device.archived && (
              <Col xs="auto" className="mb-1 ml-auto">
                <DeviceContextMenu deviceId={device.id} />
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </Nav>
  );
}

const mapStateToProps = (state, { deviceId }) => {
  return {
    devices: getDevices(state),
    device: getDevice(state, deviceId),
    hasNetworkFeature: getCurrentOrganisationHasProductCode(state, 'network_centre'),
    hasFmlog: getCurrentOrganisationHasProductCode(state, 'fmlog'),
    isSuperAdmin: getIsSuperAdmin(state),
    isAdmin: getIsAdmin(state),
  };
};

export default withNavigationDeviceProps(
  connect(mapStateToProps)(EquipmentNav)
);
